import {Foot} from "doctors-dashboard/http-clients/index";
import {PatientTemperatureOption} from "../interfaces/patient-temperature-option";

export const PatientTemperatureFeet: PatientTemperatureOption<Foot>[] = [
    {name: 'Left', value: Foot.LeftFoot},
    {name: 'Right', value: Foot.RightFoot},
];